import React, { useContext, useEffect, useState } from 'react';

import {
  Position,
  Toaster,
  Intent,
} from "@blueprintjs/core";

import NotificationContext from 'contexts/notification-context';

import './index.css';


const TYPES = {
  SUCCESS: 'success',
  WARN: 'warn',
  DANGER: 'danger'
}

const DEFAULT_DURATION = 4000;

const getIntent = (type = '') => {
  switch (type.toLowerCase()) {
    case TYPES.SUCCESS:
      return Intent.SUCCESS;
    case TYPES.DANGER:
      return Intent.DANGER;
    case TYPES.WARN:
      return Intent.WARNING;
    default:
      return Intent.NONE;
  }
}

const Notification = () => {
  const { notification = {} } = useContext(NotificationContext);
  const [hide, setHide] = useState(true);

  let toasterRef;

  useEffect(() => {
    if (notification.message) {
      if (hide) setHide(false);

      notification.intent = getIntent(notification.type);

      notification.timeout = notification.autoCancel ? DEFAULT_DURATION : 0;

      if (toasterRef) toasterRef.show(notification)
    
    }
  }, [notification]);
  
  
  const refHandlers = {
    toaster(ref){ toasterRef = ref },
  };

  return (
    <Toaster
      position={Position.TOP}
      ref={refHandlers.toaster}
      dismiss={(val) => {alert(JSON.stringify(val))}}
    />
  );
};

export default Notification;